import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as brands_actions from "data/brands/actions";
import * as categories_actions from "data/categories/actions";
import * as product_actions from "data/products/actions";
import * as producttypes_actions from "data/productTypes/actions";
import RaisedButton from "material-ui/RaisedButton";
import { Page, PageSection, PageBlock, RightDrawer } from "components/Page";

import EditionEditor from "components/Form/EditionEditor";
import PositionEditor from "components/Form/PositionEditor";
import ToggleField from "components/Form/ToggleField";

import Subheader from "material-ui/Subheader";
import Row from "components/Form/Row";
import MenuLink from "components/Navigation/MenuLink";
import ImageField from "components/Form/ImageField";

import Field from "components/Form/Field";
import DropdownField from "components/Form/DropdownField";
import * as os from "osutil";

class Product extends Component {
  state = {};

  static contextTypes = {
    router: PropTypes.object
  };

  handleCancel(id) {
    this.context.router.history.push("/admin/products");
  }

  componentWillMount() {
    this.props.actions.fetchProducttypes();
    this.props.actions.fetchBrands();
    this.props.actions.fetchCategories();
    this.props.actions.fetchProducts();
    this.props.actions.fetchProduct(this.props.params.id);
  }

  handleBrandChange = () => {
      console.log("handleBrandChange");
      if (this.refs.brandid.state.value)
      {
        console.log("handleBrandChange", this.refs.brandid.state.value, this.props.product.brandid);
        if (this.refs.brandid.state.value !== this.props.product.brandid)      
        {
            this.handleFormSubmit();
        }
      }
  }
  handleFormSubmit(event) {
    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    let merged = Object.assign(...data);
    merged.imageAlt1Url = this.refs.imageAlt1.state.url || "";
    merged.imageAlt2Url = this.refs.imageAlt2.state.url || "";
    merged.imageAlt3Url = this.refs.imageAlt3.state.url || "";
    merged.bgimageUrl = this.refs.bgimage.state.url || "";
    merged.themeimageUrl = this.refs.themeimage.state.url || "";
    merged.logoUrl = this.refs.logo.state.url || "";
    merged.disabled = this.refs.disabled.state.value || false;
    this.props.actions.updateProduct(this.props.params.id, merged);
  }
  onCheck = event => {
    return false;
  };

  render() {
    var { brands, categories, producttypes } = this.props;

    if (!this.props.product) {
      return null;
    }
    return [
      <RightDrawer key="right">
        <PageBlock label="Produkter" />
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <Subheader>
          <MenuLink label="Produkter" to="/admin/products" />
          <span className="pathsep" />
          <MenuLink label={this.props.product.name} to={this.props.params.id} />
        </Subheader>
        <div
          onSubmit={this.handleFormSubmit.bind(this)}
          className="form-inline"
        >
          <PageSection label="Detaljer">
            <Row>
              <ToggleField
                style={{ float: "right" }}
                ref="disabled"
                label="Dold"
                value={this.props.product.disabled}
              />
            </Row>
            <Row>
              <DropdownField
                ref="brandid"
                value={this.props.product.brandid}
                label="Medie"
                options={brands}
                onChange={this.handleBrandChange}
              />

              <DropdownField
                ref="categoryid"
                value={this.props.product.categoryid}
                label="Kanal"
                options={categories}
              />

              <DropdownField
                ref="producttypeid"
                value={this.props.product.producttypeid}
                label="Produkttyp"
                options={producttypes}
              />
            </Row>
            <Row>
              <Field
                ref="name"
                value={this.props.product.name}
                floatingLabelText="Rubrik"
              />
            </Row>
            <Row>
              <Field
                ref="subtitle"
                value={this.props.product.subtitle}
                floatingLabelText="Underrubrik"
              />
            </Row>
            <Row>
              <Field
                ref="productid"
                value={this.props.product.productid}
                floatingLabelText="Produkt-ID"
              />
            </Row>
            <Row>
              <Field
                multiLine={true}
                ref="description"
                value={this.props.product.description}
                floatingLabelText="Beskrivning"
              />
            </Row>
            <Row>
              <PositionEditor
                ref="positions"
                value={this.props.product.positions}
                label="Placeringsval"
              />
            </Row>
          </PageSection>
          <PageSection label="Priser">
            <Row>
              <Field
                ref="netprice"
                value={this.props.product.netprice}
                floatingLabelText="Nettopris"
              />
            </Row>
            <Row>
              <Field
                ref="grossprice"
                value={this.props.product.grossprice}
                floatingLabelText="Bruttopris"
              />
            </Row>
            <Row>
              <Field
                ref="vat"
                value={this.props.product.vat}
                floatingLabelText="Moms"
              />
            </Row>
            <Row>
              <Field
                ref="inprice"
                value={this.props.product.inprice}
                floatingLabelText="Inköpspris"
              />
            </Row>
            <Row>
              <Field
                ref="discount"
                value={this.props.product.discount}
                floatingLabelText="Rabatt"
              />
            </Row>
          </PageSection>
          <PageSection label="Bilder">
            <Row styleName="padded">
              <ImageField
                ref="themeimage"
                value={this.props.product.themeimage}
                url={this.props.product.themeimageUrl}
                label="Produktbild 1, 400 x 400"
              />
            </Row>
            <Row styleName="padded">
              <ImageField
                ref="imageAlt1"
                value={this.props.product.imageAlt1}
                url={this.props.product.imageAlt1Url}
                label="Produktbild 2, 400 x 400"
              />
            </Row>
            <Row styleName="padded">
              <ImageField
                ref="imageAlt2"
                value={this.props.product.imageAlt2}
                url={this.props.product.imageAlt2Url}
                label="Produktbild 3, 400 x 400"
              />
            </Row>
            <Row styleName="padded">
              <ImageField
                ref="imageAlt3"
                value={this.props.product.imageAlt3}
                url={this.props.product.imageAlt3Url}
                label="Produktbild 4, 400 x 400"
              />
            </Row>
            <Row styleName="padded">
              <ImageField
                ref="bgimage"
                value={this.props.product.bgimage}
                url={this.props.product.bgimageUrl}
                label="Temabild stor, 1500 x 240"
              />
            </Row>
            <Row styleName="padded">
              <ImageField
                ref="logo"
                value={this.props.product.logo}
                url={this.props.product.logoUrl}
                label="Logo"
              />
            </Row>
          </PageSection>
          <PageSection label="Datum">
            <Row styleName="padded">
              <EditionEditor
                ref="editions"
                value={this.props.product.editions}
              />
            </Row>
          </PageSection>
          <PageSection label="Övrigt">
            <Row styleName="padded">
              <Field
                multiLine={true}
                ref="materialSpecification"
                value={this.props.product.materialSpecification}
                floatingLabelText="Materialspecifikation"
              />
            </Row>
            <Row styleName="padded">
              <Field
                multiLine={true}
                ref="termsOfService"
                value={this.props.product.termsOfService}
                floatingLabelText="Annonsvilkor"
              />
            </Row>
            <Row styleName="padded">
              <RaisedButton
                onTouchTap={this.handleFormSubmit.bind(this)}
                primary={true}
                label="Spara"
              />
              <RaisedButton
                onTouchTap={this.handleCancel.bind(this)}
                label="Stäng"
              />
            </Row>
          </PageSection>
        </div>
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  var product = state.products.details.data;
  if (
    !(
      state.products.details.data &&
      state.brands.list.data &&
      state.producttypes.list.data &&
      state.categories.list.data &&
      product &&
      product.name
    )
  ) {
    return { product, pending: true };
  }

  var props = {};

  var brandid = product ? product.brandid : null;
  var producttypeid = product ? product.producttypeid : null;

  props.producttype = state.producttypes.list.data[producttypeid];
  props.product = product;
  props.pending = state.products.details.pending;
  props.brands = state.brands.list.data;
  props.categories = [];
  if (brandid) {
    var brand = state.brands.list.data[brandid];
    if (brand) {
      var categoryid = product ? product.categoryid : null;
      var categoryids = _.map(brand.categories, c => c.categoryid);
      props.producttypes = _.filter(
        os.add_key(state.producttypes.list.data),
        pt => categoryids.indexOf(pt.categoryid) >= 0
      );
      props.brand = brand;
      props.categories = brand.categories;
    }
  }

  return props;
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...brands_actions,
        ...categories_actions,
        ...product_actions,
        ...producttypes_actions
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(Product);



// WEBPACK FOOTER //
// ./src/pages/admin/products/Product.jsx